<template>
  <v-content :class="retornaClass" v-if="verificaPraExibir">
    <v-layout row wrap>
      <v-flex xs12>
        <p class="formSection mb-0">
           Integração: 
          <span
            :class="formataCorIntegracao(statusIntegracao)"
          >{{ formataStatusIntegracao(statusIntegracao) }}</span>
        </p>
        <p class="mb-0 mt-0"></p>
        <p class="mt-0 mb-1" v-if="statusIntegracao == false">
           Detalhes integração: 
          <span :class="formataCorIntegracao(statusIntegracao)">{{ mensagemIntegracao }}</span>
        </p>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
export default {
  props: {
    mensagemIntegracao: {
      type: String,
      default: null
    },
    statusIntegracao: {
      type: Boolean,
      default: null
    },
    ehBox: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    formataStatusIntegracao(msgStatus) {
      let msgDoStatus;
      if (msgStatus)
        msgDoStatus = "Dados enviados com sucesso ao Webservice do ADN.";
      else
        msgDoStatus =
          "Ocorreu um problema ao enviar os dados ao Webservice do ADN.";
      return `${msgDoStatus}`;
    },
    formataCorIntegracao(status) {
      if (status) {
        return "success--text";
      } else {
        return "error--text";
      }
    },
    mandarRequest() {
      this.$emit("chamaFuncao");
    }
  },
  computed: {
    retornaClass() {
      if (this.ehBox) {
        return "elevation-3 mt-0 mb-3 py-2";
      } else {
        return "mb-3 mt-0 pb-2 pt-0";
      }
    },
    verificaQualPerfil() {
      if (
        this.usuarioAutenticado.papeis.filter(
          papel => papel.nome == "APROVADOR_FINANCEIRO"
        ).length > 0 &&
        this.statusIntegracao == false
      ) {
        if (this.statusIntegracao) return false;
        else return true;
      } else {
        return false;
      }
    },
    usuarioAutenticado() {
      return this.$store.getters.usuarioAutenticado;
    },
    verificaPraExibir() {
      if (
        (this.statusIntegracao == false || this.statusIntegracao == null) &&
        (this.mensagemIntegracao == null || this.mensagemIntegracao == "")
      )
        return false;
      else return true;
    }
  }
};
</script>